import { appThemeColors } from "styles/appTheme";

export const TOAST_BANNER_APPEARANCE = {
  DEFAULT: "default",
  STATUS: "status",
};

export const TOAST_BANNER_MARKER = {
  TRIANGLE: "triangle",
  INFO: "info",
};

export const getBannerAppearanceConfig = (appearance) => {
  if (appearance === TOAST_BANNER_APPEARANCE.STATUS) {
    return {
      marker: TOAST_BANNER_MARKER.INFO,
      backgroundColor: appThemeColors.background.paper2,
      textColor: appThemeColors.text.heading,
      accentColor: appThemeColors.semantic.danger,
      markBackgroundColor: "transparent",
      markColor: appThemeColors.semantic.danger,
      textFontWeight: 700,
      border: `1px solid ${appThemeColors.border.default}`,
      boxShadow: "0 1px 4px rgba(10, 31, 92, 0.08)",
      borderRadius: "8px",
      padding: "16px 20px",
      borderLeftWidth: "5px",
      gap: "14px",
    };
  }

  const warn = appThemeColors.status.warn;
  return {
    marker: TOAST_BANNER_MARKER.TRIANGLE,
    backgroundColor: warn.background,
    textColor: appThemeColors.text.primary,
    accentColor: warn.color,
    markBackgroundColor: warn.background,
    markColor: warn.color,
    textFontWeight: 400,
    border: "none",
    boxShadow: "none",
    borderRadius: "14px",
    padding: "8px 12px 8px 16px",
    borderLeftWidth: "4px",
    gap: "12px",
  };
};
